import { useQuery } from '@tanstack/react-query'
import isEmpty from 'lodash/isEmpty'

import { requestBusinessObjects } from 'shared/services'
import { useJWTToken } from 'App/Auth'

const getLogger = ({ queryKey: [
    _key, // eslint-disable-line no-unused-vars
    {
        number,
        token,
    },
] }) => {
    return requestBusinessObjects({
        method: 'GET',
        url: `logger/loggernumber/${number}`,
        token,
    })
        .then((data) => {
            return data.data
        })
}

function useGetLoggerByNumber(number, enabled) {
    const token = useJWTToken()

    return useQuery({
        queryKey: [
            'getLoggerQRCodeByNumber',
            {
                number,
                token,
            },
        ],
        queryFn: getLogger,
        enabled: enabled && !isEmpty(number),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000,
    })
}

export default useGetLoggerByNumber
